module.exports = __webpack_public_path__ + "img/defaultSchool.12976c32.png";